import React, { Component } from 'react';

export class HashtagMaster extends Component {
    constructor(props) {
        super(props);
        this.state = { list: [], loading: true, editItem: null, form: {}, search: '', dragIndex: -1, dropIndex: -1, savingOrder: false };
    }

    componentDidMount() { this.load(); }

    load() {
        this.setState({ loading: true });
        fetch('api/hashtag?includeInactive=1')
            .then(r => r.ok ? r.json() : [])
            .then(list => this.setState({ list, loading: false }))
            .catch(() => this.setState({ loading: false }));
    }

    openAdd() { this.setState({ editItem: { id: 0 }, form: { label: '', keyword: '', sort: this.state.list.length, flag: 1 } }); }
    openEdit(item) { this.setState({ editItem: item, form: { ...item } }); }
    closeModal() { this.setState({ editItem: null }); }
    upd(field, val) { this.setState({ form: { ...this.state.form, [field]: val } }); }

    async save() {
        var { form, editItem } = this.state;
        if (!form.label?.trim()) { alert('กรุณากรอกข้อความที่แสดง'); return; }
        var body = {
            id: editItem.id || 0,
            label: form.label.trim(),
            keyword: (form.keyword || form.label).trim(),
            sort: parseInt(form.sort) || 0,
            flag: form.flag === 0 ? 0 : 1
        };
        try {
            var r = await fetch('api/hashtag', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body) });
            if (!r.ok) throw new Error('save failed');
            this.closeModal();
            this.load();
        } catch (e) { alert('บันทึกไม่สำเร็จ: ' + e.message); }
    }

    async del(item) {
        if (!window.confirm('ต้องการลบ "' + item.label + '" ?')) return;
        try {
            await fetch('api/hashtag/' + item.id, { method: 'DELETE' });
            this.load();
        } catch {}
    }

    async toggleActive(item) {
        var body = { ...item, flag: item.flag === 1 ? 0 : 1 };
        await fetch('api/hashtag', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body) });
        this.load();
    }

    onDragStart = (i) => (e) => {
        this.setState({ dragIndex: i });
        try { e.dataTransfer.effectAllowed = 'move'; e.dataTransfer.setData('text/plain', String(i)); } catch {}
    }
    onDragOver = (i) => (e) => {
        e.preventDefault();
        if (this.state.dropIndex !== i) this.setState({ dropIndex: i });
    }
    onDragLeave = () => this.setState({ dropIndex: -1 })
    onDrop = (i) => async (e) => {
        e.preventDefault();
        var { dragIndex, list } = this.state;
        this.setState({ dragIndex: -1, dropIndex: -1 });
        if (dragIndex < 0 || dragIndex === i) return;
        var reordered = [...list];
        var [moved] = reordered.splice(dragIndex, 1);
        reordered.splice(i, 0, moved);
        reordered.forEach((it, idx) => { it.sort = idx + 1; });
        this.setState({ list: reordered, savingOrder: true });
        try {
            await Promise.all(reordered.map(it => fetch('api/hashtag', {
                method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(it)
            })));
        } catch {}
        this.setState({ savingOrder: false });
        this.load();
    }

    getFiltered() {
        var { list, search } = this.state;
        if (!search.trim()) return list;
        var s = search.trim().toLowerCase();
        return list.filter(h => (h.label || '').toLowerCase().includes(s) || (h.keyword || '').toLowerCase().includes(s));
    }

    render() {
        var { loading, editItem, form, search, dragIndex, dropIndex, savingOrder, list } = this.state;
        var filtered = this.getFiltered();
        var canReorder = !search.trim();

        return (
            <div style={{ padding: '28px 20px 40px', maxWidth: 1100, margin: '0 auto' }}>
                <div className="d-flex justify-content-between align-items-center mb-4" style={{ flexWrap: 'wrap', gap: 10 }}>
                    <p style={{ margin: 0, fontSize: 13, color: '#888' }}>
                        <i className="fas fa-info-circle" style={{ color: '#dc3545', marginRight: 6 }}></i>
                        Hashtag ที่แสดงใน Footer — <i className="fas fa-grip-vertical"></i> <strong>ลากแถวเพื่อเรียงลำดับ</strong>
                    </p>
                    <div className="d-flex" style={{ gap: 8 }}>
                        {savingOrder && <span style={{ color: '#888', fontSize: 12, alignSelf: 'center' }}><i className="fas fa-spinner fa-spin"></i> กำลังบันทึก...</span>}
                        <button className="btn btn-danger" onClick={() => this.openAdd()}><i className="fas fa-plus"></i> เพิ่ม Hashtag</button>
                    </div>
                </div>

                <div style={{ background: '#fff', borderRadius: 10, padding: 14, boxShadow: '0 2px 12px rgba(0,0,0,0.06)', marginBottom: 16 }}>
                    <div className="input-group" style={{ maxWidth: 360 }}>
                        <span className="input-group-text" style={{ background: '#fff' }}><i className="fas fa-search" style={{ color: '#aaa' }}></i></span>
                        <input className="form-control" placeholder="ค้นหา..." value={search} onChange={e => this.setState({ search: e.target.value })} style={{ borderLeft: 'none' }} />
                    </div>
                </div>

                {loading ? (
                    <div className="text-center py-5"><div className="spinner-border text-danger"></div></div>
                ) : filtered.length === 0 ? (
                    <div className="text-center py-5" style={{ color: '#bbb' }}>
                        <i className="fas fa-hashtag" style={{ fontSize: 48, display: 'block', marginBottom: 12 }}></i>
                        ยังไม่มี Hashtag
                    </div>
                ) : (
                    <div style={{ background: '#fff', borderRadius: 10, boxShadow: '0 2px 12px rgba(0,0,0,0.06)', overflow: 'hidden' }}>
                        <table className="table table-hover" style={{ margin: 0 }}>
                            <thead style={{ background: '#f8f9fa' }}>
                                <tr>
                                    <th style={{ width: 40 }}></th>
                                    <th style={{ width: 60 }}>ลำดับ</th>
                                    <th>ข้อความที่แสดง</th>
                                    <th>คำค้นหา (hashtag)</th>
                                    <th style={{ width: 100 }}>สถานะ</th>
                                    <th style={{ width: 160, textAlign: 'right' }}>จัดการ</th>
                                </tr>
                            </thead>
                            <tbody>
                                {filtered.map((h, idx) => (
                                    <tr key={h.id}
                                        draggable={canReorder}
                                        onDragStart={canReorder ? this.onDragStart(idx) : undefined}
                                        onDragOver={canReorder ? this.onDragOver(idx) : undefined}
                                        onDragLeave={canReorder ? this.onDragLeave : undefined}
                                        onDrop={canReorder ? this.onDrop(idx) : undefined}
                                        style={{
                                            opacity: h.flag === 0 ? 0.5 : (dragIndex === idx ? 0.35 : 1),
                                            cursor: canReorder ? 'grab' : 'default',
                                            borderTop: dropIndex === idx && dragIndex > idx ? '3px solid #dc3545' : undefined,
                                            borderBottom: dropIndex === idx && dragIndex >= 0 && dragIndex < idx ? '3px solid #dc3545' : undefined,
                                            background: dragIndex === idx ? '#fff5f5' : undefined
                                        }}>
                                        <td style={{ textAlign: 'center', color: '#bbb' }}>
                                            {canReorder && <i className="fas fa-grip-vertical"></i>}
                                        </td>
                                        <td style={{ color: '#888', fontSize: 13 }}>#{h.sort}</td>
                                        <td>
                                            <span style={{ background: '#c82333', color: '#fff', padding: '4px 12px', borderRadius: 20, fontSize: 13, fontWeight: 600 }}>
                                                <i className="fas fa-hashtag" style={{ fontSize: 11, opacity: 0.7 }}></i> {h.label}
                                            </span>
                                        </td>
                                        <td style={{ fontSize: 13, color: '#555' }}><code style={{ color: '#dc3545', background: '#fff5f5', padding: '2px 8px', borderRadius: 4 }}>{h.keyword}</code></td>
                                        <td>
                                            {h.flag ? <span style={{ color: '#28a745', fontSize: 12, fontWeight: 600 }}><i className="fas fa-check-circle"></i> Active</span>
                                                : <span style={{ color: '#6c757d', fontSize: 12 }}><i className="fas fa-pause-circle"></i> Inactive</span>}
                                        </td>
                                        <td style={{ textAlign: 'right' }}>
                                            <div className="d-inline-flex" style={{ gap: 8 }}>
                                                <button className="btn btn-sm btn-outline-secondary" onClick={() => this.toggleActive(h)}>
                                                    <i className={h.flag === 1 ? 'fas fa-pause' : 'fas fa-play'}></i>
                                                </button>
                                                <button className="btn btn-sm btn-outline-primary" onClick={() => this.openEdit(h)}><i className="fas fa-edit"></i></button>
                                                <button className="btn btn-sm btn-outline-danger" onClick={() => this.del(h)}><i className="fas fa-trash"></i></button>
                                            </div>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                )}

                {editItem && (
                    <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000 }} onClick={() => this.closeModal()}>
                        <div style={{ background: '#fff', borderRadius: 12, padding: 24, width: '90%', maxWidth: 500 }} onClick={e => e.stopPropagation()}>
                            <h5 style={{ marginBottom: 16 }}>{editItem.id ? 'แก้ไข' : 'เพิ่ม'} Hashtag</h5>

                            <div className="mb-3">
                                <label style={{ fontSize: 13, fontWeight: 700 }}>ข้อความที่แสดง *</label>
                                <input className="form-control" placeholder="เช่น ญี่ปุ่น" value={form.label || ''} onChange={e => this.upd('label', e.target.value)} autoFocus />
                                <div style={{ fontSize: 11, color: '#888', marginTop: 4 }}>ข้อความนี้จะแสดงบน chip ที่ footer หน้า Home</div>
                            </div>

                            <div className="mb-3">
                                <label style={{ fontSize: 13, fontWeight: 700 }}>คำค้นหา (hashtag)</label>
                                <input className="form-control" placeholder="เช่น JAPAN (ถ้าไม่ระบุจะใช้ข้อความที่แสดง)" value={form.keyword || ''} onChange={e => this.upd('keyword', e.target.value)} />
                                <div style={{ fontSize: 11, color: '#888', marginTop: 4 }}>คลิกแล้วจะค้นหาโปรแกรมที่ติด hashtag นี้</div>
                            </div>

                            <div className="row mb-3">
                                <div className="col-md-6">
                                    <label style={{ fontSize: 13, fontWeight: 700 }}>ลำดับ</label>
                                    <input type="number" className="form-control" value={form.sort || 0} onChange={e => this.upd('sort', e.target.value)} />
                                </div>
                                <div className="col-md-6">
                                    <label style={{ fontSize: 13, fontWeight: 700 }}>สถานะ</label>
                                    <select className="form-select" value={form.flag || 1} onChange={e => this.upd('flag', parseInt(e.target.value))}>
                                        <option value="1">Active</option>
                                        <option value="0">Inactive</option>
                                    </select>
                                </div>
                            </div>

                            <div className="d-flex justify-content-end" style={{ gap: 8 }}>
                                <button className="btn btn-outline-secondary" onClick={() => this.closeModal()}>ยกเลิก</button>
                                <button className="btn btn-danger" onClick={() => this.save()}><i className="fas fa-save"></i> บันทึก</button>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        );
    }
}
